import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { fetchFeatureFlags } from "../app/actions"

const initialValue = {id: null, TenantID: "", FeatureFlagID: ""}

const AddEditTenantFeatureFlagModal = ({editTenantFeatureFlag = null, show, onHide, onSave, onDelete}) => {
    const [tenantFeatureFlag, setTenantFeatureFlag] = useState(initialValue)
    const dispatch  = useDispatch()
    const featureFlags = useSelector(store => store.app.featureFlags)

    useEffect(()=>{
        dispatch(fetchFeatureFlags())
    }, [])
    
    useEffect(()=>{

        if(editTenantFeatureFlag) {
            setTenantFeatureFlag({
                id: editTenantFeatureFlag.id,
                TenantID: editTenantFeatureFlag.TenantID,
                FeatureFlagID: editTenantFeatureFlag.FeatureFlagID
            })
        } else {
            setTenantFeatureFlag(initialValue)
        }
    }, [show])

    const handleSave = () => {
        onSave(tenantFeatureFlag)
    }

    const handleDelete = () => {
        onDelete(tenantFeatureFlag)
    }

    const handleChange = (e) => {
        setTenantFeatureFlag({
            ...tenantFeatureFlag,
            [e.target.name]: e.target.value
        })
    }

    const handleRadioButtonChange = e => {
        setTenantFeatureFlag({
            ...tenantFeatureFlag,
            [e.target.name]: e.target.value
        })
    }

    return <Modal show={show} onHide={onHide}>
        <Modal.Header>
            <Modal.Title>
                {editTenantFeatureFlag ? "Edit tenant feature flag #" + editTenantFeatureFlag.id : "Create tenant feature flag"}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            <Form.Group>
                <Form.Label>Feature flag</Form.Label>
                <Form.Control as="select" name="FeatureFlagID" value={tenantFeatureFlag.FeatureFlagID} onChange={handleChange}>
                    <option value={""}>Pick feature flag</option>
                    {featureFlags && featureFlags.map(featureFlag => <option key={featureFlag.id} value={featureFlag.id}>
                        #{featureFlag.id} {featureFlag.FeatureDescription} ({featureFlag.FeatureName})
                    </option>)}
                </Form.Control>
            </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="default" onClick={onHide}>Cancel</Button>
            {editTenantFeatureFlag && <Button onClick={handleDelete} variant="danger">Delete</Button>}
            <Button onClick={handleSave} disabled={!tenantFeatureFlag.FeatureFlagID}>Save</Button>
        </Modal.Footer>
    </Modal>
}

export default AddEditTenantFeatureFlagModal